import React, { useEffect, useState } from "react";
import { PackageMinus } from "lucide-react";
import api, { friendlyError } from "@/lib/api";
import { Card, Button, Chip, Field, Input } from "@/ui";

// Shop owner: get an email the moment any item drops below the level you set.
export default function LowStockCard({ shopId, onToast }) {
  const [data, setData] = useState(null);
  const [threshold, setThreshold] = useState(3);
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [loadErr, setLoadErr] = useState("");

  const load = () => api.get(`/low-stock${shopId ? `?shopId=${shopId}` : ""}`).then((r) => {
    setLoadErr(""); setData(r.data); setThreshold(r.data.threshold); setEnabled(r.data.enabled);
  }).catch((e) => setLoadErr(friendlyError(e)));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [shopId]);

  const save = async () => {
    setBusy(true);
    try {
      const r = await api.post("/low-stock", { shopId, threshold: Number(threshold), enabled });
      setData(r.data); onToast?.("Low-stock alerts saved.");
    } catch (e) { onToast?.(friendlyError(e)); } finally { setBusy(false); }
  };

  if (loadErr) return (
    <Card data-testid="low-stock-error">
      <p className="t-small" style={{ marginBottom: 12 }}>{loadErr}</p>
      <Button data-testid="low-stock-retry" onClick={load}>Try again</Button>
    </Card>
  );
  if (!data) return <Card data-testid="low-stock-loading"><div className="sk sk-title" style={{ marginBottom: 12 }} /><div className="sk sk-line" /></Card>;
  return (
    <Card data-testid="low-stock-card">
      <div className="row-between" style={{ marginBottom: 8 }}>
        <div className="row" style={{ gap: 10 }}>
          <span className="ph-icon" style={{ margin: 0 }}><PackageMinus size={18} strokeWidth={1.75} /></span>
          <h2 className="t-h2">low-stock alerts</h2>
        </div>
        <Chip tone={enabled ? "good" : "warn"} dot data-testid="low-stock-status">{enabled ? "on" : "off"}</Chip>
      </div>
      <p className="muted t-small" style={{ marginBottom: 12, maxWidth: 620 }}>
        We email you the moment an item drops below your level, so you can restock before it runs out.
      </p>
      <div className="row" style={{ gap: 14, alignItems: "end", flexWrap: "wrap" }}>
        <label className="row" style={{ gap: 8, cursor: "pointer" }} data-testid="low-stock-enabled">
          <input type="checkbox" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />
          <span className="t-small">email me when stock runs low</span>
        </label>
        <Field label="Alert me at or below" htmlFor="low-th" hint="pieces left">
          <Input id="low-th" type="number" min="0" data-testid="low-stock-threshold" value={threshold}
            onChange={(e) => setThreshold(e.target.value)} style={{ width: 120 }} />
        </Field>
        <Button variant="primary" data-testid="low-stock-save" loading={busy} onClick={save}>Save</Button>
      </div>
    </Card>
  );
}
